/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Champ crm
 * API description dev
 * OpenAPI spec version: 1.0
 */

export type MarketPlace = (typeof MarketPlace)[keyof typeof MarketPlace];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketPlace = {
  OZON: "OZON",
  WB: "WB",
  YM: "YM",
} as const;
